import React from 'react';
import CreateQuotation from '../components/CreateQuotation';

function NewQuotation() {
  return <CreateQuotation />;
}

export default NewQuotation;
